import { VpLoader } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { FiltersBar } from '@/components/FiltersBar/FiltersBar'
import { ProductCard } from '@/components/ProductCard'
import { ProductsViewHeader } from '@/components/ProductsHeader/ProductsViewHeader'
import { ProductsProvider } from '@/contexts/products/ProductsProvider'
import { useProductsContext } from '@/contexts/products/useProductsContext'
import { isGalleryModel, isGallerySM } from '@/types/catalog'
import { NoResults } from './NoResults'
import { ProductsSkeleton } from './ProductsSkeleton'
import './products-gallery.scss'

function ProductsGalleryContent() {
  const { t } = useTranslation()
  const { columns, viewMode, customViewSelections, isFiltersOpen, products, sentinelRef, isLoading, isFetchingNextPage, isRefreshing } = useProductsContext()

  const renderProductGallery = () => {
    if (viewMode === 'sm') {
      return products.filter(isGallerySM).map(product => (
        <ProductCard
          key={product.super_model.id}
          viewMode="sm"
          product={product}
          customView={customViewSelections}
        />
      ))
    }

    return products.filter(isGalleryModel).map(product => (
      <ProductCard
        key={product.model.id}
        viewMode="model"
        product={product}
        customView={customViewSelections}
      />
    ))
  }

  const renderGalleryContent = () => {
    if (isLoading)
      return <ProductsSkeleton rowCount={3} />

    if (products.length === 0)
      return <NoResults />

    return renderProductGallery()
  }

  return (
    <div className="products-gallery">
      <ProductsViewHeader />
      <div className="products-gallery__wrapper">
        {isFiltersOpen && <FiltersBar />}
        <div
          className="products-gallery__grid"
          aria-busy={isRefreshing}
          style={{ '--gallery-columns': columns } as React.CSSProperties}
        >
          {renderGalleryContent()}
          {isRefreshing && products.length > 0 && (
            <div className="products-gallery__refresh" role="status" aria-label={t('aria-label.refreshing-products')}>
              <VpLoader size="small" />
            </div>
          )}
          <div ref={sentinelRef} />
          {isFetchingNextPage && <ProductsSkeleton />}
        </div>
      </div>
    </div>
  )
}

export function ProductsGallery() {
  return (
    <ProductsProvider>
      <ProductsGalleryContent />
    </ProductsProvider>
  )
}
